
import React from 'react'
import 'firebase/auth'; // Additional modules as needed
import ActionVerifyEmail from '../components/ActionVerifyEmail/ActionVerifyEmail'
import ActionResetPassword from '../components/ActionResetPassword/ActionResetPassword'
import { useSearchParams } from 'react-router-dom';

const Action=() =>{
    //const mode = searchParams.mode;
    const [searchParams] = useSearchParams();
 
    const mode = searchParams.get('mode')
    console.log('mode',mode)
    switch (mode) {
        case 'verifyEmail':
            return <ActionVerifyEmail searchParams={searchParams} />
        case 'resetPassword':
            return <ActionResetPassword searchParams={searchParams} />
        default:
            return null
    }
}

export default Action